import { useTranslation } from 'next-i18next'
import { FC } from 'react'
import { CardCollectionComponentDto } from '~/modules/CardCollections/Infrastructure/CardCollectionComponentDto'
import { CardCollectionCard } from '~/modules/CardCollections/Infrastructure/Components/CardCollectionCard'
import styles from '~/modules/CardCollections/Infrastructure/Components/CardCollectionList.module.scss'

interface Props {
  cardCollections: CardCollectionComponentDto[]
}
export const CardCollectionList: FC<Props> = ({ cardCollections }) => {
  const { t } = useTranslation('card_collection_list')

  if (cardCollections.length === 0) return null

  return (
    <section className={ styles.cardCollectionList__container }>
      <h2 className={ styles.cardCollectionList__title }>
        { t('card_collection_list_title') }
      </h2>
      <div className={ styles.cardCollectionList__list }>
        {
          cardCollections.map((cardCollection) => (
            <CardCollectionCard
              cardCollection={ cardCollection }
              key={ cardCollection.id }
            />
          ))
        }
      </div>
    </section>
  )
}
